module.exports = __webpack_public_path__ + "media/press/NEWheaderv3-774359b0.png";